import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const filtersTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Filters',
  key: 'filters',
  main: {
    metadata: {
        layout: {
            rows: [
                ['fgId', 'fId', 'type'],
                ['value', 'prefix', 'application'],
            ],
        },
    },
    fields: {
        fgId: {
            label: 'Filter Group ID',
            type: 'advancedSelect',
            initial: '',
            placeholder: 'Select or create a group',
            allowCreate: true,
            options: [],
            validation: {
              required: true,
              validators: [
                {
                  type: 'length',
                  length: 64,
                },
                {
                  type: 'regexp',
                  regexp: ['letters', 'digits', '-_.~!@#$%^*+?'],
                  errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
                },
              ]
            },
        },
        fId: {
            label: 'Filter ID',
            type: 'text',
            initial: '',
            validation: {
                required: true,
                validators: [
                    {
                        type: 'Interval',
                        intervals: [[1, 65535]],
                        errorMessage: 'Must be between 0 - 65535. Please re-enter.',
                      },
                ]
            },
        },
        type: {
            label: 'Type',
            type: 'select',
            initial: 'IPADDRESS',
            options: [
                {
                    label: 'CLASSIFIER-AUTH-ID',
                    value: 'CLASSIFIER-AUTH-ID',
                },
                {
                    label: 'COLOR',
                    value: 'COLOR',
                },
                {
                    label: 'DESTINATIONADDRESS',
                    value: 'DESTINATIONADDRESS',
                },
                {
                    label: 'DESTINATIONQUALIFIER',
                    value: 'DESTINATIONQUALIFIER',
                },
                {
                    label: 'DESTINATION-ROUTE-CLASS',
                    value: 'DESTINATION-ROUTE-CLASS',
                },
                {
                    label: 'DSFIELD',
                    value: 'DSFIELD',
                },
                {
                    label: 'ICMP-TYPE',
                    value: 'ICMP-TYPE',
                },
                {
                    label: 'ICMP-CODE',
                    value: 'ICMP-CODE',
                },
                {
                    label: 'IGMP-TYPE',
                    value: 'IGMP-TYPE',
                },
                {
                    label: 'IPADDRESS_RANGE',
                    value: 'IPADDRESS_RANGE',
                },
                {
                    label: 'IPv4 Address',
                    value: 'IPADDRESS',
                },
                {
                    label: 'IPv4 Address and Port',
                    value: 'IPADDRESS:PORT',
                },
                {
                    label: 'IPv6 Address',
                    value: 'IPADDRESS6',
                },
                {
                    label: 'IPv6 Address and Port',
                    value: 'IPADDRESS6:PORT',
                },
                {
                    label: 'IP-FLAGS',
                    value: 'IP-FLAGS',
                },
                {
                    label: 'IP-FRAG-OFFSET',
                    value: 'IP-FRAG-OFFSET',
                },
                {
                    label: 'LOCAL',
                    value: 'LOCAL',
                },
                {
                    label: 'NAME',
                    value: 'NAME',
                },
                {
                    label: 'PORT',
                    value: 'PORT',
                },
                {
                    label: 'PORT_RANGE',
                    value: 'PORT_RANGE',
                },
                {
                    label: 'PRECEDENCE',
                    value: 'PRECEDENCE',
                },
                {
                    label: 'PROTOCOL',
                    value: 'PROTOCOL',
                },
                {
                    label: 'SOURCEADDRESS',
                    value: 'SOURCEADDRESS',
                },
                {
                    label: 'SOURCEQUALIFIER',
                    value: 'SOURCEQUALIFIER',
                },
                {
                    label: 'SOURCE-ROUTE-CLASS',
                    value: 'SOURCE-ROUTE-CLASS',
                },
                {
                    label: 'STRING',
                    value: 'STRING',
                },
                {
                    label: 'TCP-FLAGS',
                    value: 'TCP-FLAGS',
                },
                {
                    label: 'TOS',
                    value: 'TOS',
                },
                {
                    label: 'TRAFFIC-CLASS',
                    value: 'TRAFFIC-CLASS',
                },
                {
                    label: 'USER-PACKET-CLASS',
                    value: 'USER-PACKET-CLASS',
                },
            ],
            optionsFirstTranslatable: true,
        },
        value: {
            label: 'Value',
            type: 'text',
            initial: '',
            validation: {
                required: true,
            }
        },
        prefix: {
            label: 'Prefix',
            type: 'select',
            initial: 'NULL',
            options: [
            {
                label: 'NULL',
                value: 'NULL',
            },
            {
                label: 'NOT',
                value: 'NOT',
            },
            ],
            optionsTranslatable: true,
        },
        application: {
            label: 'Application',
            type: 'text',
            initial: '',
            validation: {
              validators: [
                {
                  type: 'length',
                  length: 32,
                },
                {
                    type: 'regexp',
                    regexp: [
                      'letters',
                      'digits',
                      'spaces',
                      '-_.~!@#$%^*+?',
                    ],
                    errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
                  },
              ],
            },
        },
        VALUELABEL: {
            type: 'label',
            label: 'Value'
        },
        MORE_FRAGMENTS: {
            label: 'More Fragments',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        DONT_FRAGMENT: {
            label: 'Dont Fragment',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        RESERVED: {
            label: 'Reserved',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        ACK: {
            label: 'ACK',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        FIN: {
            label: 'Fin',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        PUSH: {
            label: 'Push',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        RST: {
            label: 'RST',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        SYN: {
            label: 'SYN',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
        URGENT: {
            label: 'Urgent',
            type: 'checkbox',
            initial: false,
            className: 'no-margin'
        },
    },
  },
};
